import gsap from "gsap";

export default function handleScrollingImageGrids() {
    if($('.js-horizontal-scroll-section').length > 0) {
        handleScrollingImageGrid();
    }
}

function handleScrollingImageGrid() {
    gsap.to(".js-horizontal-scroll", {
        scrollTrigger: {
            trigger: ".js-horizontal-scroll-section",
            start: "top bottom",
            end: "bottom top",
            scrub: 1,
        },
        xPercent: -50,
        ease: "none"
    });

    gsap.to(".js-horizontal-scroll-alt", {
        scrollTrigger: {
            trigger: ".js-horizontal-scroll-section",
            start: "top bottom",
            end: "bottom top",
            scrub: 1,
        },
        xPercent: 50,
        ease: "none"
    });
}